import 'core-js'
import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/main.scss'
import 'normalize.css'
import VueLazyload from 'vue-lazyload'
import VueWindowSize from 'vue-window-size';
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos';
import 'aos/src/sass/aos.scss';
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

AOS.init({
  offset: 100,
  easing: 'ease-out',
  once: true,
  duration: 600
})

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueWindowSize);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})

new Vue({
  render: h => h(App),
}).$mount('#app')
